import React, {Component} from 'react';
import ECareServiceDetail from './eCareServiceDetail.js';

import './eCareLinkService.css';

class eCareLinkService extends Component {

	constructor(props) {
		super(props);
	}
	
	/**
 * "boxTitle": "e-Care Link Android App Service",
"boxImage": "https://www.three.com.hk:10043/media/plans/red.png",
"boxDesc": "Content is currently available in",
"boxDesc2": "Chinese",
"boxDesc3": "only.",
"boxDesc4": "For any enquiries, please contact our Sales Hotline at 1032.",
"boxUrl": ""
 * 
 * **/

	openLink = (u) => {if(u!=="") window.location.href = u; };

    render(){
		let general = this.props.general;
		var simPlan = this.props.serviceBox;
		var html = simPlan.map((item, index) => {
			return	<div className='col-xs-12 col-md-4 e-care-div' key={index} onClick={() => this.openLink(item.boxUrl)}>
                        <div className='eCareServiceDetail'>
                            <ECareServiceDetail 
								boxImage={item.boxImage}
								boxTitle={item.boxTitle}
								boxDesc={item.boxDesc}
								boxDesc2={item.boxDesc2}
								boxDesc3={item.boxDesc3}
								boxDesc4={item.boxDesc4}
							/>
                        </div>
                </div>
		});
		
        return (
            <div id="eCareLinkService">
				<div className="title">{general.subheadline1}</div>
				<div className="row">
					{html}
				</div>
			</div>
        );
    }
}

export default eCareLinkService;